import { holesky, hoodi, mainnet } from 'viem/chains';
import { useConfiguredChainId } from './wagmi/configured';

/**
 * fixme: this is a temporary solution until we have a better way to handle block explorers
 */
const blockExplorers = {
  [mainnet.id]: {
    name: 'Beaconscan',
    url: 'https://beaconcha.in',
  },
  [holesky.id]: {
    name: 'Beaconscan',
    url: 'https://holesky.beaconcha.in',
  },
  [hoodi.id]: {
    name: 'Beaconscan',
    url: 'https://hoodi.beaconcha.in',
  },
};

export default function useEthereumBeaconscanBlockExplorer() {
  const environmentChainId = useConfiguredChainId();
  if (blockExplorers.hasOwnProperty(environmentChainId)) {
    return blockExplorers[environmentChainId as keyof typeof blockExplorers];
  }
}
